export default "__VITE_ASSET__CWqCQtL3__"